import MultiSwitch from './components/MultiSwitch';

export default MultiSwitch;





// WEBPACK FOOTER //
// ./src/lib/index.js